
// Generated with baseline-styles - Do not modify.
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.styles = {
    "box": "box-45f5b72f",
    "center": "center-45f5b72f",
    "middle": "middle-45f5b72f",
    "no-wrap": "no-wrap-45f5b72f",
    "fit-width": "fit-width-45f5b72f",
    "fit-height": "fit-height-45f5b72f",
    "fit-both": "fit-both-45f5b72f",
    "noWrap": "no-wrap-45f5b72f",
    "fitWidth": "fit-width-45f5b72f",
    "fitHeight": "fit-height-45f5b72f",
    "fitBoth": "fit-both-45f5b72f"
};
exports.styleSource = ".box-45f5b72f{position:relative;box-sizing:border-box}.center-45f5b72f{display:flex;flex-direction:column;align-items:center}.middle-45f5b72f{display:flex;flex-direction:column;justify-content:center}.no-wrap-45f5b72f{white-space:nowrap}.fit-width-45f5b72f{width:100%}.fit-height-45f5b72f{height:100%}.fit-both-45f5b72f{width:100%;height:100%}";
exports.default = exports.styles;
            
module.moduleType = "style";
